import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Grid,
  Box,
  Tabs,
  Tab,
  AppBar,
  FormControl,
  InputLabel,
  FormHelperText,
  Input,
  InputAdornment,
  IconButton,
  Modal,
  Paper,
} from "@material-ui/core";
import styles from "./style.module.scss";
import { withRouter } from "react-router";
import Button from "@material-ui/core/Button";
import LoginActions from "../../Redux/LoginRedux";
import { LoginSelectors } from "../../Redux/LoginRedux";
import Backdrop from "@material-ui/core/Backdrop";
import MaskedInput from "react-text-mask";
import CircularProgress from "@material-ui/core/CircularProgress";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Loading from "../Loading/Loading";

class LoginSignup extends Component {
  constructor(props) {
    console.log("LoginSignup props ", props);
    super(props);
    this.state = {
      currentTab: "Login",
      username: "",
      password: "",
      name: "",
      phone: "",
      tab: 0,
      phoneError: false,
      emailError: false,
      passwordError: false,
      forgotPassword: false,
      showPasswordSignup: false,
      showPasswordLogin: false,
      showConfirmationModal: false,
    };
  }

  componentDidMount() {}

  // componentWillReceiveProps() {
  //   if (this.props.isUserLoggedIn) {
  //     this.props.onClose();
  //   }
  // }
  componentDidUpdate(prevProps) {
    if (prevProps.isUserLoggedIn !== this.props.isUserLoggedIn) {
      if (this.props.isUserLoggedIn) {
        this.props.onClose();
      }
    }
  }

  handlePhoneChange = (event) => {
    this.setState({
      phone: event.target.value,
    });
  };

  login = (event) => {
    event.preventDefault();
    if (this.state.password.length < 6) {
      // inside if condition
    } else if (this.state.password != "" && this.state.username != "") {
      this.props.dispatch(
        LoginActions.loginRequest(
          this.state.username,
          this.state.password,
          this.props.nextScreen,
          this.props.onClose,
          this.props.match.url
        )
      );
    }
  };

  formatPhoneNumber = (phoneNumberString) => {
    var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return "(" + match[1] + ") " + match[2] + "-" + match[3];
    }
    return null;
  };

  // signup = (event) => {
  //   event.preventDefault();
  //   var passwordError = false;
  //   var emailError = false;
  //   var phoneError = false;
  //   if (this.state.password.length < 6) {
  //     passwordError = true;
  //   }
  //   if (
  //     !/^[(][0-9][0-9][0-9][)][ ][0-9][0-9][0-9][-][0-9][0-9][0-9][0-9]/.test(
  //       this.state.phone
  //     )
  //   ) {
  //     phoneError = true;
  //   }
  //   if (
  //     !/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(
  //       this.state.username
  //     )
  //   ) {
  //     emailError = true;
  //   }
  //   if (!passwordError && !emailError && !phoneError) {
  //     if (
  //       this.state.name != "" &&
  //       this.state.username != "" &&
  //       this.state.password != "" &&
  //       this.state.phone != ""
  //     ) {
  //       this.props.dispatch(
  //         LoginActions.signupRequest(
  //           this.state.name,
  //           this.state.phone,
  //           this.state.username,
  //           this.state.password,
  //           this.props.nextScreen,
  //           this.props.onClose,
  //           this.props.match.url
  //         )
  //       );
  //     }
  //   }
  //   this.setState({
  //     phoneError: phoneError,
  //     emailError: emailError,
  //     passwordError: passwordError,
  //   });
  // };

  signup = (event) => {
    event.preventDefault();
    var passwordError = false;
    var emailError = false;
    var phoneError = false;

    // Validation checks...
    if (this.state.password.length < 6) {
      passwordError = true;
    }
    if (
      !/^[(][0-9][0-9][0-9][)][ ][0-9][0-9][0-9][-][0-9][0-9][0-9][0-9]/.test(
        this.state.phone
      )
    ) {
      phoneError = true;
    }
    if (
      !/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(
        this.state.username
      )
    ) {
      emailError = true;
    }

    if (!passwordError && !emailError && !phoneError) {
      // Prompt before submitting the form
      this.setState({ showConfirmationModal: true }); // Show confirmation modal
    } else {
      // Update state to reflect error statuses
      this.setState({
        phoneError: phoneError,
        emailError: emailError,
        passwordError: passwordError,
      });
    }
  };

  handleConfirmation = () => {
    this.setState({ showConfirmationModal: false }); // Hide confirmation modal

    // Perform form submission if user clicks 'Yes' in the confirmation modal
    if (
      this.state.name !== "" &&
      this.state.username !== "" &&
      this.state.password !== "" &&
      this.state.phone !== ""
    ) {
      this.props.dispatch(
        LoginActions.signupRequest(
          this.state.name,
          this.state.phone,
          this.state.username,
          this.state.password,
          this.props.nextScreen,
          this.props.onClose,
          this.props.match.url
        )
      );
    }
  };

  handleChangeView = (event, value) => {
    this.setState({
      tab: value,
    });
  };

  forgotPassword = (event) => {
    event.preventDefault();
    var emailError = false;
    if (
      !/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(
        this.state.username
      )
    ) {
      emailError = true;
    }
    if (!emailError) {
      if (this.state.username != "") {
        this.props.dispatch(
          LoginActions.forgotPassword(this.state.username, this.props.onClose)
        );
      }
    }
  };

  render() {
    return (
      <Grid container style={{ backgroundColor: "#fff" }}>
        {/* <Backdrop className={styles.backdrop} open={this.props.loggingLoading}>
          <CircularProgress color="inherit" />
        </Backdrop> */}
        {/* {this.props.isUserLoggedIn && (
          <Grid item xs={12} sm={12}>
            <span>Welcome {this.props.userInfo?.name}</span>
          </Grid>
        )} */}
        <AppBar position="static" color="transparent">
          <Tabs
            value={this.state.tab}
            onChange={this.handleChangeView}
            indicatorColor="secondary"
            variant="fullWidth"
          >
            <Tab label="Signup" />
            <Tab
              label={this.state.forgotPassword ? "Forgot Password" : "Login"}
            />
          </Tabs>
        </AppBar>
        <div
          className={styles.tabpanel}
          role="tabpanel"
          hidden={this.state.tab !== 0}
          id={`wrapped-tabpanel-${0}`}
          aria-labelledby={`wrapped-tab-${0}`}
        >
          {this.state.tab == 0 && (
            <Box p={3}>
              {/* {this.props.loggingLoading && <Loading />} */}
              {/* !this.props.loggingLoading && */}
              {
                <Grid container>
                  <form className={styles.tabpanel} onSubmit={this.signup}>
                    <div>
                      <FormControl fullWidth={true}>
                        <InputLabel htmlFor="signup-name">Name</InputLabel>
                        <Input
                          id="signup-name"
                          aria-describedby="signup-name-text"
                          onChange={(value) =>
                            this.setState({ name: value.target.value })
                          }
                        />
                      </FormControl>
                    </div>
                    <div>
                      <FormControl fullWidth={true}>
                        <InputLabel htmlFor="signup-phone">Phone</InputLabel>
                        <Input
                          id="signup-phone"
                          aria-describedby="signup-phone-text"
                          onChange={this.handlePhoneChange}
                          name="phone"
                          // onChange={(value) =>
                          //   this.setState({ phone: value.target.value })
                          // }
                          inputComponent={TextMaskCustom}
                        />
                        {this.state.phoneError && (
                          <FormHelperText
                            error
                            id="my-helper-text"
                            label="Error"
                          >
                            Phone number is invalid
                          </FormHelperText>
                        )}
                      </FormControl>
                    </div>
                    <div>
                      <FormControl fullWidth={true}>
                        <InputLabel htmlFor="signup-email">Email</InputLabel>
                        <Input
                          fullWidth={true}
                          id="signup-email"
                          aria-describedby="signup-email-text"
                          onChange={(value) =>
                            this.setState({ username: value.target.value })
                          }
                        />
                        {this.state.emailError && (
                          <FormHelperText
                            error
                            id="my-helper-text"
                            label="Error"
                          >
                            Email is invalid
                          </FormHelperText>
                        )}
                      </FormControl>
                    </div>
                    <div>
                      <FormControl fullWidth={true}>
                        <InputLabel htmlFor="signup-phone">Password</InputLabel>
                        <Input
                          type="password"
                          id="signup-password"
                          aria-describedby="signup-password-text"
                          type={
                            this.state.showPasswordSignup ? "text" : "password"
                          }
                          onChange={(value) =>
                            this.setState({ password: value.target.value })
                          }
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={() =>
                                  this.setState({
                                    showPasswordSignup:
                                      !this.state.showPasswordSignup,
                                  })
                                }
                                onMouseDown={(event) => event.preventDefault()}
                              >
                                {this.state.showPasswordSignup ? (
                                  <Visibility />
                                ) : (
                                  <VisibilityOff />
                                )}
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                        {this.state.passwordError && (
                          <FormHelperText
                            error
                            id="my-helper-text"
                            label="Error"
                          >
                            Password must be atleast 6 characters
                          </FormHelperText>
                        )}
                      </FormControl>
                    </div>
                    <br />
                    <div>
                      <Button
                        color="secondary"
                        variant="contained"
                        type="submit"
                      >
                        Signup
                      </Button>
                      <Button
                        onClick={() => this.props.onClose()}
                        variant="text"
                      >
                        Close
                      </Button>
                    </div>
                  </form>

                  <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    open={this.state.showConfirmationModal}
                    onClose={() =>
                      this.setState({ showConfirmationModal: false })
                    }
                    disableBackdropClick
                  >
                    <Box
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                      }}
                    >
                      <Paper
                        style={{
                          width: 400,
                          backgroundColor: "white", // Change background color here
                          border: "1px solid #000",
                          boxShadow: 24,
                          padding: "20px",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-end",
                        }}
                      >
                        <h5
                          style={{
                            color: "black",
                            fontSize: "18px",
                            marginBottom: "20px",
                          }}
                        >
                          We will send the order notifications through Email.
                        </h5>
                        <Box display="flex" justifyContent="flex-end" gap={10}>
                          <Button
                            color="error"
                            variant="contained"
                            style={{ marginRight: "10px" }}
                            onClick={() =>
                              this.setState({ showConfirmationModal: false })
                            }
                          >
                            No
                          </Button>
                          <Button
                            color="secondary"
                            variant="contained"
                            onClick={this.handleConfirmation}
                            style={{ marginRight: "0" }}
                          >
                            Yes
                          </Button>
                        </Box>
                      </Paper>
                    </Box>
                  </Modal>
                </Grid>
              }
            </Box>
          )}
        </div>
        <div
          role="tabpanel"
          className={styles.tabpanel}
          hidden={this.state.tab !== 1}
          id={`wrapped-tabpanel-${1}`}
          aria-labelledby={`wrapped-tab-${1}`}
        >
          {this.state.tab == 1 && (
            <Box p={3}>
              {/* {this.props.loggingLoading && <Loading />}
              !this.props.loggingLoading && */}
              {
                <Grid container>
                  <form
                    className={styles.tabpanel}
                    onSubmit={
                      this.state.forgotPassword
                        ? this.forgotPassword
                        : this.login
                    }
                  >
                    <div>
                      <FormControl fullWidth={true}>
                        <InputLabel htmlFor="signup-email">Email</InputLabel>
                        <Input
                          fullWidth={true}
                          id="signup-email"
                          aria-describedby="signup-email-text"
                          onChange={(username) =>
                            this.setState({ username: username.target.value })
                          }
                        />
                      </FormControl>
                    </div>
                    {!this.state.forgotPassword && (
                      <div>
                        <FormControl fullWidth={true}>
                          <InputLabel htmlFor="signup-phone">
                            Password
                          </InputLabel>
                          <Input
                            type="password"
                            id="signup-password"
                            aria-describedby="signup-password-text"
                            type={
                              this.state.showPasswordLogin ? "text" : "password"
                            }
                            onChange={(value) =>
                              this.setState({ password: value.target.value })
                            }
                            endAdornment={
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={() =>
                                    this.setState({
                                      showPasswordLogin:
                                        !this.state.showPasswordLogin,
                                    })
                                  }
                                  onMouseDown={(event) =>
                                    event.preventDefault()
                                  }
                                >
                                  {this.state.showPasswordLogin ? (
                                    <Visibility />
                                  ) : (
                                    <VisibilityOff />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            }
                          />
                        </FormControl>
                      </div>
                    )}
                    <br />

                    <Grid container>
                      <Grid item xs={12} sm={6}>
                        <Button
                          color="secondary"
                          variant="contained"
                          type="submit"
                        >
                          {this.state.forgotPassword ? "Submit" : "Login"}
                        </Button>

                        <Button
                          onClick={() => this.props.onClose()}
                          variant="text"
                        >
                          Close
                        </Button>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <div className={styles.forgotPasswordButton}>
                          {this.state.forgotPassword && (
                            <>
                              <Button
                                style={{ marginBottom: "10px" }}
                                color="secondary"
                                onClick={() =>
                                  this.setState({ forgotPassword: false })
                                }
                              >
                                Login
                              </Button>
                              <br />
                            </>
                          )}
                          {!this.state.forgotPassword && (
                            <>
                              <Button
                                style={{ marginBottom: "10px" }}
                                color="secondary"
                                onClick={() =>
                                  this.setState({ forgotPassword: true })
                                }
                              >
                                Forgot Password
                              </Button>
                              <br />
                            </>
                          )}
                        </div>
                      </Grid>
                    </Grid>
                  </form>
                </Grid>
              }
            </Box>
          )}
        </div>
      </Grid>
    );
  }
}

function TextMaskCustom(props) {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      guide={false}
      mask={[
        "(",
        /[1-9]/,
        /\d/,
        /\d/,
        ")",
        " ",
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ]}
      showMask
    />
  );
}

const mapStateToProps = (state) => {
  return {
    isUserLoggedIn: LoginSelectors.isUserloggedIn(state),
    loggingLoading: LoginSelectors.isLoading(state),
    loginError: LoginSelectors.getLoginError(state),
    signupError: LoginSelectors.getSignupError(state),
    signupErrorMessage: LoginSelectors.getSignupErrorMessage(state),
    userInfo: LoginSelectors.getUserInfo(state),
  };
};

export default withRouter(connect(mapStateToProps)(LoginSignup));
